import React, { Component } from 'react';
import _ from 'underscore';
import { Row, Col, Table, Button, Popconfirm, Pagination, Checkbox, Input, Modal, Select, Spin } from 'antd';
import FormModal from '../../components/FormModal2';
import { app } from "../../app";
import api from "../../api";
import utils from "../../utils";

const Option = Select.Option;

class TETeamPublic extends Component {
    constructor (props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            dataList: [],
            recordList: [],
            classList: [],
            rtotal: 0,
            rpage: 1,
            total: 0,
            page: 1,
            edit_item: {},
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
        await this.handleClassData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    async componentWillReceiveProps (props) {
        let { team } = this.props;
        if (team.teamno !== props.team.teamno) {
            let { show_record } = this.state;
            let state = {
                dataList: [],
                recordList: [],
                operation: 0,
                rtotal: 0,
                rpage: 1,
                total: 0,
                edit_item: {},
            };
            if (show_record) {
                state.show_record = false;
            }
            await this.setData(state);
            await this.handleData();
        }
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 公开类别数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleClassData = async () => {
        await this.setData({ class_loading: true });
        let params = {
            class_type: 1,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.OpenClassData, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        this.setData({ class_loading: false, classList: data });
    };

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true });
        let { team } = this.props,
            params = {
                page,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamOpenList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            let operation = 0;
            for (let i = 0; i < data.length; i++) {
                if (data[i].is_operate === 1) operation++;
            }
            this.setData({
                operation,
                selectedRowKeys: [],
                data_loading: false,
                dataList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            });
        }
    };

    /**
     * 操作记录数据处理
     * @param rpage
     * @returns {Promise<void>}
     */
    handleRecordData = async (rpage = 1) => {
        await this.setData({ rpage, record_loading: true });
        let { team } = this.props,
            params = {
                page: rpage,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamOpenoPerateList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (rpage === this.state.rpage) {
            this.setData({
                record_loading: false,
                recordList: utils.addArrayKey(data),
                rtotal: parseInt(total || 0),
            });
        }
    };

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = (e) => {
        let checked = e.target.checked;
        let selectedRowKeys = [];
        if (checked) {
            selectedRowKeys = _.range(1, this.state.operation + 1);
        }
        this.setData({ selectedRowKeys });
    };

    /**
     * 关闭编辑框
     */
    handleCloseEditModal = () => {
        this.setData({ edit_visible: false });
    }

    /**
     * 打开编辑框
     * @param edit_item
     */
    handleOpenEditModal = (edit_item = {}) => {
        this.setData({ edit_visible: true, edit_item });
    }

    /**
     * 编辑
     * @param values
     */
    handleEdit = async (values) => {
        if (this.state.edit_loading) return;
        await this.setData({ edit_loading: true });
        let { team } = this.props, { edit_item, page } = this.state;
        values.indexno = app.getData('indexno');
        values.account = app.getData('account');
        let state = { edit_loading: false };
        if (edit_item.id) {
            values.id = edit_item.id;
            let { flag, msg } = await app.post(api.TeamOpenSave, values);
            await this.setData(state);
            if (flag === 1) {
                app.alert("编辑成功", "success");
                this.handleCloseEditModal();
                await this.handleData(page);
            } else {
                app.alert(msg, "error");
            }
        } else {
            values.teamno = team.teamno;
            let { flag, msg } = await app.post(api.TeamOpenAdd, values);
            await this.setData(state);
            if (flag === 1) {
                app.alert("发布成功", "success");
                this.handleCloseEditModal();
                await this.handleData(page);
            } else {
                app.alert(msg, "error");
            }
        }
    }

    /**
     * 删除
     * @param indexs
     * @returns {Promise<void>}
     */
    handleDelete = async (indexs) => {
        let { page, total, dataList } = this.state;
        let ids = [];
        for (let i = 0; i < dataList.length; i++) {
            if (indexs.indexOf(i + 1) > -1) {
                ids.push(dataList[i].id);
            }
        }
        let count = total - ids.length,
            lp = count % 20 === 0 ? parseInt(count / 20) : parseInt(count / 20) + 1;
        if (page > lp) page = lp;
        let id = ids.join(","), params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, msg } = await app.post(api.TeamOpenDel, params);
        if (flag === 1) {
            app.alert("删除成功", "success");
            await this.handleData(page);
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 打开详情
     * @param item
     */
    handleOpenDetail = (item) => {
        let { show_record } = this.state;
        Modal.info({
            title: "查看详情",
            centered: true,
            destroyOnClose: true,
            width: 800,
            okText: "确定",
            content: (
                <div>
                    <h1 style={{ textAlign: "center" }}>{item.open_title}</h1>
                    <Row type="flex" justify="space-between"
                         style={{ color: "#999", padding: "20px 0", borderTop: "1px solid #ddd" }}>
                        {show_record ?
                            (
                                <Col>
                                    <span>操作日期: {item.submit_time}</span>
                                    <span style={{ marginLeft: 20 }}>操作人:{item.vname}</span>
                                </Col>) : (
                                <Col>
                                    <span>发布日期: {item.submit_time}</span>
                                    <span style={{ marginLeft: 20 }}>发布人:{item.vname}</span>
                                </Col>
                            )
                        }
                        <Col>公开类别: {item.open_class_name}</Col>
                    </Row>
                    <p>{item.open_content}</p>
                </div>
            ),
        });
    };

    render () {
        let {
                data_loading, record_loading, recordList, dataList, selectedRowKeys, total, page, rtotal, rpage, edit_visible,
                edit_item, edit_loading, show_record, classList, class_loading, operation
            } = this.state,
            rowSelection = {
                selectedRowKeys,
                onChange: (keys) => {
                    this.setData({ selectedRowKeys: keys });
                },
                getCheckboxProps: (record) => {
                    let props = {};
                    if (record.is_operate !== 1) {
                        props.disabled = true;
                    }
                    return props;
                }
            }, formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 16, offset: 1 },
            },
            columns = [
                {
                    title: '发布时间',
                    dataIndex: 'submit_time',
                    key: 'submit_time',
                    width: '15%'
                },
                {
                    title: '公开类别',
                    dataIndex: 'open_class_name',
                    key: 'open_class_id',
                    width: '15%'
                },
                {
                    title: '标题',
                    dataIndex: 'open_title',
                    key: 'open_title',
                    width: '20%'
                },
                {
                    title: '详情',
                    dataIndex: 'open_content',
                    key: 'open_content',
                    width: '15%',
                    render: (content, record) => {
                        return (
                            <div style={{ color: "#3399CC", cursor: "pointer" }}
                                 onClick={() => this.handleOpenDetail(record)}>详情</div>);
                    }
                },
                {
                    title: '发布人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%'
                },
                {
                    title: '操作',
                    dataIndex: 'is_operate',
                    key: 'is_operate',
                    width: '20%',
                    render: (is_operate, item, index) => {
                        if (is_operate === 1) {
                            let disabled = selectedRowKeys.length > 1;
                            return (
                                <span>
                                    <Popconfirm placement="bottom"
                                                title="确定删除？"
                                                cancelText="取消"
                                                okText="确定"
                                                onConfirm={() => this.handleDelete([index + 1])}
                                    >
                                        <Button size="small" type="danger" style={{ marginRight: 20 }}
                                                disabled={disabled} ghost>删除</Button>
                                    </Popconfirm>
                                    <Button size="small" type="primary" disabled={disabled}
                                            onClick={() => this.handleOpenEditModal(item)}>编辑</Button>
                                </span>
                            );
                        } else {
                            return <span style={{ color: "#999" }}>无权操作</span>;
                        }
                    }
                },
            ],
            columns2 = [
                {
                    title: '操作时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '15%'
                },
                {
                    title: '操作前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '20%'
                },
                {
                    title: '操作后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '20%'
                },
                {
                    title: '详情',
                    dataIndex: 'open_content',
                    key: 'open_content',
                    width: '10%',
                    render: (content, record) => {
                        let item = {
                            submit_time: record.work_time,
                            open_title: record.work_title,
                            open_content: record.work_content,
                            open_class_name: record.open_class_name,
                            vname: record.work_name,
                        };
                        return (
                            <div style={{ color: "#3399CC", cursor: "pointer" }}
                                 onClick={() => this.handleOpenDetail(item)}>详情</div>);
                    }
                },
                {
                    title: '操作记录',
                    dataIndex: 'work_status',
                    key: 'work_status',
                    width: '20%',
                    render (status, { update_type }) {
                        let text = '';
                        switch (status) {
                            case '1':
                                text = '添加';
                                break;
                            case '2':
                                text = '编辑';
                                break;
                            case '3':
                                text = '删除';
                                break;
                            default:
                                text = '';
                                break;
                        }
                        return text + update_type;
                    }
                },
                {
                    title: '操作人',
                    dataIndex: 'work_name',
                    key: 'work_name',
                    width: '15%'
                },
            ];
        return (
            <div className="team-dynamic">
                <Row className="head" type="flex" justify="space-between">

                    <Button onClick={async () => {
                        this.setData({ show_record: !show_record })
                        await this.handleRecordData();
                    }}>{show_record ? '返回' : '操作记录'}</Button>
                    <h2 className="title">队内公开</h2>
                    <div style={{ minWidth: 100 }}>
                        <Button onClick={() => this.handleOpenEditModal()} hidden={show_record}>发布公开</Button>
                    </div>
                </Row>
                <div style={{ height: 'calc(100% - 41.5px)' }} hidden={!show_record}>
                    <Table columns={columns2}
                           locale={app.tbLocale(record_loading)}
                           dataSource={recordList}
                           loading={record_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           pagination={false}
                           size="small"
                           footer={recordList.length === 0 ? null : () => {
                               return (
                                   <div hidden={recordList.length === 0} style={{ textAlign: 'right' }}>
                                       <Pagination total={rtotal} size="small" pageSize={20} current={rpage}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handleRecordData}/>
                                   </div>
                               );
                           }}
                    />
                </div>
                <div style={{ height: 'calc(100% - 41.5px)', margin: 0 }} hidden={show_record}>
                    <Table columns={columns}
                           locale={app.tbLocale(data_loading)}
                           dataSource={dataList}
                           loading={data_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           rowSelection={rowSelection}
                           pagination={false}
                           size="small"
                           footer={dataList.length === 0 ? null : () => {
                               return (
                                   <Row>
                                       <Col span={10}>
                                           <div>
                                               <Checkbox onChange={this.handleAllSel} disabled={operation === 0}
                                                         checked={operation !== 0 && operation === selectedRowKeys.length}>全选</Checkbox>
                                               <Popconfirm title="确定删除？" cancelText="取消" okText="确定"
                                                           onConfirm={() => this.handleDelete(selectedRowKeys)}
                                               >
                                                   <Button style={{ margin: '0 20px' }} type="danger"
                                                           disabled={selectedRowKeys.length === 0}>删除</Button>
                                               </Popconfirm>
                                           </div>
                                       </Col>
                                       <Col span={14} style={{ textAlign: 'right' }}>
                                           <Pagination total={total} size="small" pageSize={20}
                                                       onChange={this.handleData}
                                                       current={page} showTotal={(total) => `总数量：${total}`}/>
                                       </Col>
                                   </Row>
                               );
                           }}
                    />
                </div>
                <FormModal
                    modal={{
                        visible: edit_visible,
                        title: edit_item.id ? "编辑公开" : "发布公开",
                        onCancel: this.handleCloseEditModal,
                        okText: "确认",
                        cancelText: "取消",
                        confirmLoading: edit_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                    }}
                    onSubmit={this.handleEdit}
                >
                    {
                        [
                            {
                                formItemLayout,
                                label: "公开类别",
                                name: "open_class_id",
                                options: {
                                    rules: [
                                        { required: true, message: '请选择公开类别' },
                                    ],
                                    initialValue: edit_item.open_class_id
                                },
                                component: (
                                    <Select placeholder="选择公开类别"
                                            notFoundContent={class_loading ? <Spin size="small"/> : "暂无数据"}>
                                        {
                                            classList.map((cla, index) => {
                                                return (
                                                    <Option key={index} value={cla.id}>{cla.open_class_name}</Option>
                                                );
                                            })
                                        }
                                    </Select>
                                )
                            },
                            {
                                formItemLayout,
                                label: "标题",
                                name: "open_title",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入标题' },
                                    ],
                                    initialValue: edit_item.open_title
                                },
                                component: (
                                    <Input placeholder="填写标题"/>
                                )
                            },
                            {
                                formItemLayout,
                                label: "公开内容",
                                name: "open_content",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入内容' },
                                    ],
                                    initialValue: edit_item.open_content
                                },
                                component: (
                                    <Input.TextArea placeholder="填写内容" autosize={{ minRows: 4, maxRows: 10 }}/>
                                )
                            }
                        ]
                    }
                </FormModal>
            </div>
        );
    }
}

export default TETeamPublic;


// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamPublic.jsx